import uuid from 'uuid';
import { allWidgets } from 'components/widgets';
import { widgetResolver } from 'utils/pageLoader';

export default function inflater(typeOrDetails, store = null) {
  if (!Array.isArray(typeOrDetails)) {
    typeOrDetails = [typeOrDetails]; // eslint-disable-line no-param-reassign
  }

  const [type, payload] = typeOrDetails;
  const staticWidget = allWidgets[type];

  if (!staticWidget) {
    return false;
  }

  const widget = {
    id: uuid.v4(),
    type,
    payload: { ...allWidgets[type].manifestInfo.defaultPayload, ...payload },
    componentId: allWidgets[type].manifestInfo.componentId, // just guessing this is what i need to do right here welp
  };

  if (store) {
    widgetResolver(store, widget);
  }

  return widget;
}
